import { InjectionToken } from '@angular/core';
import { PayoutAccountsDataService } from '../repositories/payout-accounts-data.service';

export const PAYOUT_ACCOUNTS_DATA_SERVICE =
  new InjectionToken<PayoutAccountsDataService>('PAYOUT_ACCOUNTS_DATA_SERVICE');
